import request from '@/utils/request'

export function addCart(params) {
  return request({
    url: '/add_cart',
    method: 'post',
    data: params
  })
}
export function getCart() {
  return request({
    url: '/get_cart',
    method: 'get',
  })
}
export function deleteCart(newpid) {
  return request({
    url: '/delete_cart',
    method: 'delete',
    params: { newpid },
  })
}


// WEBPACK FOOTER //
// ./src/api/cart.js